
import { useContext, useState, useEffect } from "react";

import { AnswerContext } from "../../../state/answers";

import { ViewContext } from "../../../state/view";

import { EMAIL_PATTERN } from "../../../lib/config";

import { Button } from "../../../components/button";

import { Form } from "../../../components/form";

import { Required } from "../../../components/required";

import { findQuestionsByViewId } from "../../../lib/helper";

import { Error } from "../../../components/error";

const validateEmail = email => EMAIL_PATTERN.test( email );

export function Access() {

  const { selectedAnswers, updateAnswers, finalScore, payload } = useContext( AnswerContext );

  const { view, updateView } = useContext( ViewContext );

  const [ email, setEmail ] = useState( '' );

  const [ isEmailInvalid, setIsEmailInvalid ] = useState( false );

  const [ marketoForm, setMarketoForm ] = useState( null );

  const question = findQuestionsByViewId( view )[0];
  
  const handleSubmit = event => {

    event.preventDefault();
    
    if ( ! validateEmail( email ) ) return setIsEmailInvalid( true );

    updateAnswers( question.id, email );

  }

  useEffect( () => {

    if ( typeof MktoForms2 === 'object' ) {

      MktoForms2.loadForm( 'https://info.biomerieux.com', '315-VKA-657', 4944 );

      MktoForms2.whenReady( reference => {
        
        setMarketoForm( reference );

        reference.onSuccess( () => {

          updateView( prevViewId => prevViewId + 1 );
        
        } );
      
      } );

    }

  }, [] );

  useEffect( () => {
    
    if ( ! marketoForm || ! finalScore || ! payload ) return;

    const jobFunction = selectedAnswers[ 0 ].answers[ 0 ].value;

    marketoForm.setValues( {

      Email: email,

      Job_Function__c: jobFunction === 'Other' ? null : jobFunction,

      PM_Custom1: finalScore,

      pMCustom2: JSON.stringify( payload )

    } );

    marketoForm.submit();

  }, [ finalScore, payload ] );

  return (

    <div data-form-wrapper className="grid">

      <div data-form-placeholder className="flex items-center justify-center" hidden={ marketoForm }>

        <svg viewBox="0 0 24 24" className="w-16 animate-spin" fill="none" aria-hidden="true">

          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />

          <path className="opacity-75" fill="currentColor"
          
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />

        </svg>

      </div>

      <div hidden={ ! marketoForm }>

        <form id="mktoForm_4944" hidden></form>

        <Form onSubmit={ handleSubmit }>

          <div className="flex flex-col gap-5">
            
            <div>

              <p className="text-grey-text text-sm sm:text-base">
                
                { question.label }

                <Required />
                
              </p>

              <input

                aria-invalid={ isEmailInvalid }

                className="border border-input bg-grey-abalaster w-full h-10 sm:h-13 px-3 sm:px-5 text-sm sm:text-base outline-none focus-visible:ring-[2px] focus-visible:border-blue-fresh focus-visible:ring-blue-fresh/50 aria-invalid:ring-red/20 aria-invalid:border-red" 

                type="email"

                value={ email } 

                onChange={ e => setEmail( e.target.value ) }

              />

              { isEmailInvalid && <Error className="text-xs">{ question.error }</Error> }

            </div>

            <p className="text-black text-xs">

              By clicking the button below, you have read and agree to the
              
              {' '}

              <a className="underline" href="https://www.biomerieux.com/us/en/privacy/protection-of-personal-information-and-commitment-to-privacy.html">
              
                Privacy Policy
              
              </a>

              {' '}
              
              and agree to receive emails from bioMérieux. You can unsubscribe at any time.

            </p>

          </div>

          <Button type='submit'>

            Get My Results

          </Button>

        </Form>

      </div>

    </div>

  )

}
